import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.08))\n    drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.08))\n    drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components'; // Note: this is a visual match to the spec due to differences on
// shadow handling and implementation between sketch and the code below
// former part 1 shadow drop-shadow(0 2px 2px rgba(0, 0, 0, 0.15))
// former part 2 drop-shadow(0 0 2px rgba(0, 0, 0, 0.2));

export var injectLevel2Shadow = function injectLevel2Shadow() {
  return css(_templateObject());
};
export var injectCardShadow = function injectCardShadow() {
  return css(_templateObject2());
};